// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2ZID_cudZEceT8 {\n  border-top: 1px solid rgba(9, 30, 66, 0.13);\n  margin: 10px 0 0;\n  padding-top: 8px;\n}\n._36duO82OGUF5vP {\n  width: 100%;\n  cursor: pointer;\n  display: block;\n  font-weight: normal;\n  padding: 6px 12px;\n  position: relative;\n  margin: 0 -12px;\n  text-decoration: none;\n  background-color: transparent;\n  color: #172B4D;\n}\n._36duO82OGUF5vP:hover {\n  background-color: rgba(9, 30, 66, 0.04);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ctaDivider": "_2ZID_cudZEceT8",
	"ctaButton": "_36duO82OGUF5vP"
};
export default ___CSS_LOADER_EXPORT___;
